<template>
    <b-modal
        ref="documentPreviewModal"
        cancel-variant="outline-secondary"
        size="xl"
        :ok-title="$t('Component(Button):close')"
        scrollable
        ok-only
        centered
        :title="fileName"
        @hidden="cleanup"
    >
        <Overlay :show="showOverlay">
            <b-alert v-if="errorMessage" show variant="danger">
                <div class="alert-body">{{ errorMessage }}</div>
            </b-alert>
            <object v-else-if="downloaded" :data="url" :type="mimeType" width="100%" :height="height">
                unable to display document
            </object>
        </Overlay>
    </b-modal>
</template>

<script>
import { BAlert, BModal } from 'bootstrap-vue'
import {ProductApi} from "@core/api";
import Overlay from "@core/components/common/Overlay";

export default {
    components: {BAlert, BModal, Overlay},
    props: {
        product: {
            required: true,
        },
        file: {
            type: Object,
            default() {
                return {
                    id: null,
                    file: {
                        mime: 'application/pdf',
                        name: ''
                    }
                };
            }
        }
    },
    data() {
        return {
            showOverlay: true,
            downloaded: false,
            url: null,
            height: this.calculateHeight(),
            errorMessage: null,
            downloadRevision: 0,
        }
    },
    computed: {
        fileName() {
            return this.file && this.file.file ? this.file.file.name : ''
        },
        mimeType() {
            return this.file && this.file.file && this.file.file.mime
                ? this.file.file.mime
                : 'application/octet-stream'
        },
    },
    mounted() {
        this.resizeObserver = new ResizeObserver(this.onResize);
        this.resizeObserver.observe(document.body);
    },
    beforeDestroy() {
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
        }
        this.cleanup();
    },
    methods: {
        onResize() {
            this.height = this.calculateHeight();
        },
        show() {
            this.cleanup();
            this.$refs.documentPreviewModal.show();
            this.download();
        },
        download() {
            if (!this.file || !this.file.id) {
                return false;
            }

            const revision = ++this.downloadRevision;
            this.showOverlay = true;
            this.errorMessage = null;

            return ProductApi
                .downloadDocument(this.product.id, this.file.id)
                .then(response => {
                    if (revision !== this.downloadRevision) {
                        return;
                    }
                    this.url = URL.createObjectURL(new Blob([response.data], {type: this.mimeType}));
                    this.downloaded = true;
                    this.showOverlay = false;
                })
                .catch(error => {
                    if (revision !== this.downloadRevision) {
                        return;
                    }
                    const data = error && error.response ? error.response.data : null;
                    this.errorMessage = (data && (data.detail || data['hydra:description']))
                        || (error && error.message)
                        || this.$t('Component(Error):default');
                    this.showOverlay = false;
                });
        },
        cleanup() {
            this.downloadRevision += 1;
            if (this.url) {
                URL.revokeObjectURL(this.url);
            }
            this.url = null;
            this.downloaded = false;
            this.errorMessage = null;
            this.showOverlay = true;
        },
        calculateHeight() {
            return (document.body.offsetHeight - 200) + 'px;';
        }
    },
}
</script>
